import { createAction, props } from '@ngrx/store';
import { addNewAccountType } from '../../core/models/Interfaces/addNewAccount';

export const addNewAccountRequest = createAction(
  'add-new-account',
  props<{ params: addNewAccountType }>(),
);
export const addNewAccountReceived = createAction(
  'add-new-account-received',
  props<any>(),
);
export const addNewAccountFailed = createAction(
  'add-new-account-failed',
  props<any>(),
);

export const resetNewAccountState = createAction('add-new-account-reset');
